import { IRawAreaList, IRawStop } from "@/api/busStaitions/types";
import { IBusStation } from "@/shared/types/busStaition";
import { ICity } from "@/shared/types/city";
import { TTransportType } from "../types/types";

function adapterCities(cities: Record<string, ICity>): ICity[] {
    const citieKeys = Object.keys(cities);
    const updated = citieKeys.reduce((array: ICity[], key: string) => {
        array.push(cities[key]);
        return array;
    }, []);

    return updated;
}

interface IBoundsOptions {
    checkZoomRange: boolean;
    duration: number;
    zoomMargin?: number;
}

function adapterStaitionForForm(
    areas: IRawAreaList,
    isRoad: boolean = false,
) {

    return areas.map((a) => {
        const stop = a?.stops?.stop;

        // если нет вложенной остановки — возвращаем только area
        if (!stop) {
            return {
                area_id: a.id.toString(),
                area_name: a.name,
                // стоп-данные отсутствуют
                isRoad,
            };
        }

        // если stop есть — собираем полноценный объект
        return {
            area_id: a.id.toString(),
            area_name: a.name,

            stop_id: stop.stop_id?.toString(),
            stop_name: stop.stop_name,

            transport_type: stop.transport_type,
            stop_latitude: stop.stop_latitude,
            stop_longitude: stop.stop_longitude,

            isRoad,
        };
    });
}

export interface IFormStationForMap {
  area_id: string;
  area_name: string;
  stop_id?: string;
  stop_name?: string;
  transport_type?: TTransportType;
  stop_latitude?: string;
  stop_longitude?: string;
  isRoad?: boolean;
}

/**
 * Маппит станции из формата adapterStaitionForForm
 * в формат IBusStation для отображения на карте.
 *
 * @param formStations - массив станций из формы (adapterStaitionForForm)
 * @param cityId - опциональный id города, если нужно проставить city_id
 */
function mapFormStationsToBusStations(
  formStations: IFormStationForMap[],
  cityId?: number | string
): IBusStation[] {
  return formStations.map<IBusStation>((s) => ({
    // если есть stop_name — используем его, иначе area_name
    name: s.stop_name ?? s.area_name,

    // id остановки, если есть, иначе id area
    id: s.stop_id ?? s.area_id,

    transport_type: s.transport_type,
    stop_latitude: s.stop_latitude,
    stop_longitude: s.stop_longitude,

    city_id: cityId !== undefined ? Number(cityId) : undefined,

    area_id: s.area_id,
    area_name: s.area_name,
    isRoad: s.isRoad,
  }));
}

export {
    adapterCities,
    adapterStaitionForForm,
    mapFormStationsToBusStations,
}